import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export function setDateToNoon(date: Date | undefined) {
  if (!date) return undefined;
  const d = new Date(date);
  d.setHours(12, 0, 0, 0);
  return d;
}
